import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api_comm from "../../common/lib";

export const getIncentiveNoticeBoard = createAsyncThunk(
	"Incentive/NoticeBoard",
	async (isWeb, { getState }) => {
		const state = getState();
		let contentareaObj;

		try {
			let contentTypes = await api_comm(
				"get",
				`/site/api/v2/dynamic_content/areas`,
				{},
				state.Login.Auth.session_token
			);

			if (isWeb) {
				contentareaObj = contentTypes?.data?.data?.filter(
					(contentType) =>
						contentType.contentarea_key === "web_portal_home_page"
				);
			} else {
				contentareaObj = contentTypes?.data?.data?.filter(
					(contentType) =>
						contentType.contentarea_key === "android_app_home_page"
				);
			}

			let IncentiveNotice = await api_comm(
				"get",
				`/site/api/v2/dynamic_content/active/${contentareaObj[0].contentarea_guid}`,
				{},
				state.Login.Auth.session_token
			);

			return IncentiveNotice?.data?.data;
		} catch (e) {
			if (e.data.error) {
				console.log(e.data.data.error);
			}
			console.log("Error:::", e);
			return e?.message;
		}
	}
);

const initialState = {
	Notice: {},
	loading: true,
};

export const IncentiveNoticeBoardSlice = createSlice({
	name: "IncentiveNoticeBoard",
	initialState,
	reducers: {
		setNoticeBoard: (state, action) => {
			state.Notice = action.payload;
		},
	},
	extraReducers: {
		[getIncentiveNoticeBoard.pending]: (state, action) => {
			state.loading = true;
		},
		[getIncentiveNoticeBoard.fulfilled]: (state, action) => {
			// console.log("action.payload getIncentivePayouts ==> ", action.payload);
			state.Notice = action.payload;
			state.loading = false;
		},
		[getIncentiveNoticeBoard.rejected]: (state, action) => {
			state.Notice = {};
			state.error = action.payload;
			state.loading = false;
		},
	},
});

export const { setNoticeBoard } = IncentiveNoticeBoardSlice.actions;

export default IncentiveNoticeBoardSlice.reducer;
